import { z } from 'zod';

export const zodDeleteCallOffEndpointSchema = z.tuple([
  z.literal('calloffs'),
  z.uuid(),
]);
